module.exports = __webpack_public_path__ + "static/media/win.170a9e91.jpg";